import loadable from '@loadable/component';

export const OrgDashboardGradFairsHomePageLoadable = loadable(
  () => import('./OrgDashboardGradFairsHomePage'),
  { resolveComponent: (module) => module.OrgDashboardGradFairsHomePage },
);
